export default __webpack_public_path__ + "static/media/logo.1af62b63.png";